export const environment = {
  production: true,
  environmentName: 'production',
  apiUrl: 'https://theperfectmuse-api.fly.dev/api',
  sentryDsn: 'https://16d9505f7e6b583726cbc797483a2632@o4511568531619840.ingest.de.sentry.io/4511568541843536',
};
